import { FC } from 'react'

import { IconSizes } from '@inno-ui/icons'
import { Spinner, SpinnerSizes } from '@inno-ui/spinner'
import clsx from 'clsx'

import { AuthButtonColor, AuthButtonVariant } from './AuthButton.constant'
import styles from './AuthButton.module.scss'
import { AuthButtonProps } from './AuthButton.types'

export const AuthButton: FC<AuthButtonProps> = ({
  variant,
  colorType = AuthButtonColor.LIGHT,
  isBold = false,
  label,
  isLoading = false,
  fullWidth = false,
  ...props
}) => {
  const buttonClassname = clsx(
    styles.buttonBase,
    {
      [styles.whiteFilled]: variant === AuthButtonVariant.FILLED,
      [styles.whiteGhostLight]:
        variant === AuthButtonVariant.GHOST &&
        colorType === AuthButtonColor.LIGHT,
      [styles.whiteGhostDark]:
        variant === AuthButtonVariant.GHOST &&
        colorType === AuthButtonColor.DARK,
      [styles.whiteGhostDarker]:
        variant === AuthButtonVariant.GHOST &&
        colorType === AuthButtonColor.GHOST_DARKER,
      [styles.whiteFilledBlue]:
        variant === AuthButtonVariant.FILLED_BLUE &&
        colorType === AuthButtonColor.GHOST_DARKER,
      [styles.fullWidth]: fullWidth,
      [styles.boldText]: isBold
    },
    props.className
  )

  return (
    <button {...props} className={buttonClassname}>
      {isLoading && (
        <div className={styles.spinner}>
          <Spinner size={SpinnerSizes.XS} />
        </div>
      )}
      {props.icon && !isLoading && (
        <props.icon
          className={styles.icon}
          size={IconSizes.Size16}
          color='var(--white)'
        />
      )}
      <span>{label}</span>
    </button>
  )
}
